// src/data/huiyi.ts
export interface Dangjians {
    name: string;
    time: string;
    url: string;
}

export const dangjian: Dangjians[] = [
    {
        name: "2019年党建工作总结",
        time: "----",
        url: "/documents/2019年党建工作总结.pdf"
    },
    {
        name: "2020年党建工作总结",
        time: "----",
        url: "/documents/2020年党建工作总结.pdf"
    },
    {
        name: "2021年党建工作总结",
        time: "----",
        url: "/documents/2021年党建工作总结.pdf"
    },
    {
        name: "2022年党建工作总结",
        time: "----",
        url: "/documents/2022年党建工作总结.pdf"
    },
    {
        name: "2023年党建工作总结",
        time: "----",
        url: "/documents/2023年党建工作总结.pdf"
    },
    {
        name: "山东省神经科学学会、省阿尔茨海默病防治协会举行中国共产党建党104周年庆祝活动",
        time: "2025年7月1日",
        url: "/documents/山东省神经科学学会、省阿尔茨海默病防治协会举行中国共产党建党104周年.pdf"
    },
    // 可以继续添加更多会议...
    //   {
    //     name: "",
    //     time: "",
    //     url: ""
    //   },
];